module.exports = __webpack_public_path__ + "img/qr_code.7a480c76.jpg";